import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

type AssistanceRequest = {
  created_at: string;
  expected_dispensing_date: string;
  status: string;
  patient_medical_record_number: string;
  fill_num: number;
  patient_id: number;
  patient_first_name: string;
  patient_last_name: string;
};

type AssistanceRequestResponse = {
  data: AssistanceRequest[];
  pagination: {
    total: number;
    page_size: number;
    current_page: number;
  };
};

export type Params = {
  patientId: string;
  page: number;
  requestId?: string;
};

export const useQueryAssistanceRequests = ({ patientId, page, requestId }: Params) => {
  const params = new URLSearchParams();

  if (patientId) {
    params.append('patient_id', patientId);
  }
  if (page) {
    params.append('page', page.toString());
  }
  if (requestId) {
    params.append('id', requestId);
  }

  return useQuery({
    queryKey: ['assistance-requests', patientId, page, requestId],
    queryFn: async () => {
      const { data = [], meta } = await axios.get<AssistanceRequestResponse>(
        `/assistance_requests/by_patient?per=10&${params.toString()}`
      );
      return {
        data: data as AssistanceRequest[],
        pagination: meta,
      };
    },
    retry: 0,
    enabled: !!localStorage.getItem('Authorization'),
  });
};
